import Vue from 'vue';
import Index from './index.vue';
// eslint-disable-next-line no-unused-vars
import style from './style/index.less';

import VueClipboard from 'vue-clipboard2';
Vue.use(VueClipboard);
Vue.config.ignoredElements = ['wx-open-launch-weapp'];

import { initVConsole, getUrlParameter } from '@/common/utils';
import { outsightService as service } from '@/service';
(() => {
  initVConsole();
  let devEnv = getUrlParameter('__dev__');
  if (devEnv) {
    service.changeBaseURL(devEnv);
  }
})();

window.$vue = new Vue({
  el: '#app',
  render: h => h(Index)
});
